/**
 * Invoice Ninja (https://invoiceninja.com).
 *
 * @link https://github.com/invoiceninja/invoiceninja source repository
 *
 * @copyright Copyright (c) 2022. Invoice Ninja LLC (https://invoiceninja.com)
 *
 * @license https://www.elastic.co/licensing/elastic-license
 */

export const enum Frequency {
  Daily = '1',
  Weekly = '2',
  TwoWeeks = '3',
  FourWeeks = '4',
  Monthly = '5',
  TwoMonths = '6',
  ThreeMonths = '7',
  FourMonths = '8',
  SixMonths = '9',
  Annually = '10',
  TwoYears = '11',
  ThreeYears = '12',
}
